import {Router} from 'react-router-dom';
import React, {useEffect} from 'react';

import {SAVED_SESSION_STORAGE_KEY} from '../../../data/persist/store-state';
import Screen from '../Screen';
import TopBar from '../../elements/TopBar/TopBar';
import styles from './GlobalErrorScreen.module.scss';

const GLOBAL_ERROR_STORAGE_KEY = 'FatalError',
    LAST_RUN_HAD_ERROR = !!sessionStorage.getItem(GLOBAL_ERROR_STORAGE_KEY);
sessionStorage.removeItem(GLOBAL_ERROR_STORAGE_KEY);

const GlobalErrorScreen = props => {
    const header = <TopBar icons={[]}>Error</TopBar>,
        reload = !LAST_RUN_HAD_ERROR;

    useEffect(() => {
        setTimeout(() => {
            sessionStorage.setItem(GLOBAL_ERROR_STORAGE_KEY, 1);
            sessionStorage.removeItem(SAVED_SESSION_STORAGE_KEY);
            if (reload) {
                location.reload(true);
            } else if (location.pathname != '/') {
                location.pathname = '/';
            }
        }, 2000);
    }, []);

    return (
        <Router history={app.history}>
            <Screen header={header}>
                <div className={[styles.GlobalErrorScreen, 'fill-container text-center content text'].join(' ')}>
                    <p>Something went wrong!</p>
                    {reload ? <p>Reloading app...</p> : null}
                </div>
            </Screen>
        </Router>
    );
};

export default GlobalErrorScreen;
